/* eslint-disable no-nested-ternary */

import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CustomButton from '../components/button/View';
import { CommentShow } from './CommentShow';
import { getStyledStatus } from 'services/GetStatusStyle';


const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  btnsround: {
    padding: '8px',
    fontSize: '14px',
    lineHeight: '24px',
    minWidth: '110px',
    marginLeft: '8px',
    borderRadius: '35px',
    marginBottom: '8px',
    textAlign: 'center',
    display: 'inline-block',
    fontFamily: 'VodafoneRg-bold',

  },
  titleSub: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '1.5rem',
    margin: '1rem 0 1rem 0',
    textAlign: 'center',
    paddingTop: '1rem',
    color: '#333',
  },
  backButton: { marginRight: theme.spacing(1) },
  instructions: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  instructions1: { marginTop: theme.spacing(1), marginBottom: theme.spacing(3) },
}));


const IdeaHeader = (props) => { 
  const { isCheckForEvalutor,isHackathonChallenge , innovateUserIsEvaluatorOrNot,approvedText,status, onEdit, onDelete, onReject, onApprove, onScorecard, onAddEvaluator,  isAdmin, isOrgnizer, isEvaluator, isOwner, isInnovator, getJsonEvaluatorForRatingIsLoading,onAddBusinessScorecard, challengeStatus,challengeEndDate, onViewHistory, onMoveToDraft, moveToDraftIsLoading, evaluatorHasScorecard, isEvaluatorAssignedToIdea } = props
  // console.log('isCheckForEvalutor', isCheckForEvalutor)
  const classes = useStyles()
  const isDraftValidateStatus = status

  const [ideaStatusColor,setIdeaStatusColor] = useState('')
  const [ideaStatusName,setIdeaStatusName] = useState('')

// const canEdit = isDraftValidateStatus === "DRAFT" && (isOwner || isAdmin);
const canEdit = (isDraftValidateStatus === "DRAFT" && isOwner) || isAdmin || isOrgnizer


// 1) status based finish (use the exact value your API returns)
const isFinishedByStatus = challengeStatus === "FINISHED";

// 2) end-date based finish (challengeEndDate is a string like "Feb 25, 2026, 5:00:00 PM")
const endTime = challengeEndDate ? new Date(challengeEndDate).getTime() : NaN;
const isFinishedByEndDate = Number.isFinite(endTime) && Date.now() > endTime;

// console.log("endTime ==> ", endTime)
// console.log("isFinishedByEndDate ==> ", isFinishedByEndDate)

// Final disable flag
const disableEdit = isFinishedByStatus || isFinishedByEndDate;
const disableEditByStatus = isDraftValidateStatus === "DRAFT" && disableEdit


useEffect(()=> {
  const {name,image,color} = getStyledStatus(status)
  setIdeaStatusColor(color)
  setIdeaStatusName(name)
}, [status])

  return(
  <div>
    <div>
      <span><strong>Status:</strong></span>
      <span className={classes.btnsround} style={{ backgroundColor: ideaStatusColor || 'red', color: '#fff' }}>{ ideaStatusName || status || 'Unknown'}</span>
    </div>
    {Boolean(approvedText)  && 
      (isAdmin || isOrgnizer || isOwner) &&  ( 
      <CommentShow
        commentTitle='Admin Comment'
        commentSummary={approvedText}
      />
      )
    }
    <div>

   {/* if challenge Status Finish no need to provide edit and submit idea */}
   { canEdit && disableEditByStatus && <div> <b> The challenge you were tagged in has expired. </b> <p></p> </div> }
{  
  canEdit  
    ? <CustomButton  text="Edit Idea" action={onEdit}  btnDisable={disableEditByStatus} />
    : null
}

{/* {console.log("check condtion role !isHackathonChallenge && !isEvaluator", !isHackathonChallenge , !isEvaluator)} */}
{   
  isDraftValidateStatus === "DRAFT"
    ? null
    : isHackathonChallenge
      ? (isAdmin || isOrgnizer) && <CustomButton text="Approve" action={onApprove} />
      : ((isEvaluator && isEvaluatorAssignedToIdea) || isOrgnizer || isAdmin) && (
        <CustomButton
          text="Approve"
          action={onApprove}
          btnDisable={isEvaluator && !isAdmin && !isOrgnizer && !evaluatorHasScorecard}
          title={isEvaluator && !isAdmin && !isOrgnizer && !evaluatorHasScorecard ? 'No scorecard assigned to you' : ''}
        />
      )
}


     { (isAdmin || isOrgnizer) &&  <CustomButton text="Delete Idea" action={onDelete} /> }
      {/* { isAdmin &&  <CustomButton text="Reject Idea" action={onReject} /> } */}
       
       {/* when isHackathonChallenge is true than visible to scorecard for hackthon periods */}
      { 
        isDraftValidateStatus === "DRAFT" ? null :  
        // isHackathonChallenge && innovateUserIsEvaluatorOrNot ? isEvaluator &&
        isCheckForEvalutor &&
           <CustomButton disabled={getJsonEvaluatorForRatingIsLoading}  text={getJsonEvaluatorForRatingIsLoading ? 'Loading...' : 'Scorecard'}   action={onScorecard} />   
        } 
      
      { isDraftValidateStatus === "DRAFT" ? null :  
        (isAdmin || isOrgnizer) && <CustomButton text="Add Evaluator" action={onAddEvaluator} /> 
      }
      
      {/* when isHackathonChallenge is false than visible to add business scorecard for innovate south africa */}
      {  isDraftValidateStatus === "DRAFT"
        ? null
        : !isHackathonChallenge && (isAdmin || isOrgnizer) && <CustomButton text=" Add Business Scorecard " action={onAddBusinessScorecard } />
      }

      { isDraftValidateStatus !== "DRAFT" && <CustomButton text="View History" action={onViewHistory} /> }

       { isDraftValidateStatus !== "DRAFT" && isAdmin && <CustomButton text="Move to Draft" action={onMoveToDraft} /> }


    </div>
  </div>
)}

export default IdeaHeader;
